import classNames from "classnames";
import { Typography } from "components/atoms";
import { ProgressSummaryMobileFilters } from "../ProgressSummaryMobileFilters";
import { Dispatch, SetStateAction, useState } from "react";
import { ProgressSummaryMobileTestDetails } from "../ProgressSummaryMobileTestDetails";
import { BackIcon, Spinner } from "components/atoms/Icon";
import { useGetOverallProgressQuery } from "services/homeApi";
import { FetchError } from "components/molecules";
import { decodeToken } from "utils/functions/decodeToken";
import { getOfficeHoursDisplayName } from "utils/functions/getOfficeHoursDisplayName";
import { checkPastOrFutureDate } from "utils/functions/checkPastOrFutureDate";
import "./index.scss";

interface SelectedBtnState {
  [key: string]: boolean;
  "1": boolean;
  "2": boolean;
  "3": boolean;
  "4": boolean;
}

interface IProps {
  setIsShowMobileTestDetails?: Dispatch<SetStateAction<boolean>>;
  clickedGraphNameMobile?: undefined | string;
  theme: "light" | "dark";
}

export const ProgressSummaryMobile: React.FC<IProps> = ({
  setIsShowMobileTestDetails,
  clickedGraphNameMobile,
  theme,
}) => {
  const [selectedBtn, setSelectedBtn] = useState<SelectedBtnState>({
    "1": true,
    "2": false,
    "3": false,
    "4": false,
  });
  const [filterDropdown, setFilterDropdown] = useState<
    null | string | { [key: number]: string }
  >(null);

  const payload = decodeToken();

  const userId = payload ? payload.userid : null;
  const productCode = payload ? payload.productcode : null;
  const offeringCode = payload ? payload.offeringcode : null;

  const { data, isLoading, isError } = useGetOverallProgressQuery({
    Userid: userId,
    Productcode: productCode,
    Offeringcode: offeringCode,
  });

  const getTitle = (type: string | undefined) => {
    switch (type) {
      case "Attendance":
        return "Attendance Details";
      case "Homework":
        return "Homework Details";
      case "Tests":
        return "Tests Details";
      case "TopicFocus":
        return `Guarantee Requirements: ${getOfficeHoursDisplayName(payload?.testtype || "")}`;
      default:
        return "Diagnostic Exams Details";
    }
  };

  const getFilteterData = (dataArr: any, type: string): any => {
    if (
      type === "Diagnostics" &&
      filterDropdown &&
      Object.values(filterDropdown).length > 0
    ) {
      if (selectedBtn[1] === true) {
        return dataArr[Object.values(filterDropdown)[0]];
      } else if (selectedBtn[2] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) =>
            value.Status !== "Completed" &&
            value.Status !== "Complete" &&
            checkPastOrFutureDate("isFuture", value.DueDate)
        );
      } else if (selectedBtn[3] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) =>
            value.Status === "Complete" || value.Status === "Completed"
        );
      } else if (selectedBtn[4] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) =>
            value.Status !== "Complete" &&
            value.Status !== "Completed" &&
            checkPastOrFutureDate("isPast", value.DueDate)
        );
      }
    } else if (
      type === "Attendance" &&
      filterDropdown &&
      Object.values(filterDropdown).length > 0
    ) {
      if (selectedBtn[1] === true) {
        return dataArr[Object.values(filterDropdown)[0]];
      } else if (selectedBtn[2] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter((value: any) =>
          checkPastOrFutureDate("isFuture", value.ClassDateTZ)
        );
      } else if (selectedBtn[3] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) => value.Status === "Attended"
        );
      } else if (selectedBtn[4] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) =>
            value.Status !== "Attended" &&
            checkPastOrFutureDate("isPast", value.ClassDateTZ)
        );
      }
    } else if (
      type === "Homework" &&
      filterDropdown &&
      Object.values(filterDropdown).length > 0
    ) {
      if (selectedBtn[1] === true) {
        return dataArr[Object.values(filterDropdown)[0]];
      } else if (selectedBtn[2] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) =>
            value.Status !== "Completed" &&
            value.Status !== "Complete" &&
            checkPastOrFutureDate("isFuture", value.DueDate)
        );
      } else if (selectedBtn[3] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) =>
            value.Status === "Complete" || value.Status === "Completed"
        );
      } else if (selectedBtn[4] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) =>
            value.Status !== "Complete" &&
            value.Status !== "Completed" &&
            checkPastOrFutureDate("isPast", value.DueDate)
        );
      }
    } else if (type === "Tests") {
      if (selectedBtn[1] === true) {
        return dataArr;
      } else if (selectedBtn[2] === true) {
        return dataArr.filter(
          (value: any) =>
            value.Status !== "Completed" &&
            value.Status !== "Complete" &&
            checkPastOrFutureDate("isFuture", value.DueDate)
        );
      } else if (selectedBtn[3] === true) {
        return dataArr.filter(
          (value: any) =>
            value.Status === "Complete" || value.Status === "Completed"
        );
      } else if (selectedBtn[4] === true) {
        return dataArr.filter(
          (value: any) =>
            value.Status !== "Complete" &&
            value.Status !== "Completed" &&
            checkPastOrFutureDate("isPast", value.DueDate)
        );
      }
    } else if (
      type === "TopicFocus" &&
      filterDropdown &&
      Object.values(filterDropdown).length > 0
    ) {
      if (selectedBtn[1] === true) {
        return dataArr[Object.values(filterDropdown)[0]];
      } else if (selectedBtn[2] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) =>
            value.Status !== "Attended" &&
            checkPastOrFutureDate(
              "isFuture",
              value.NearFutureSegments.length > 0
                ? value.NearFutureSegments[0].StarttimeUTC
                : value.ClassDateTZ
            )
        );
      } else if (selectedBtn[3] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) => value.Status === "Attended"
        );
      } else if (selectedBtn[4] === true) {
        return dataArr[Object.values(filterDropdown)[0]].filter(
          (value: any) =>
            (value.Status === "Not Attended" && checkPastOrFutureDate(
              "isPast",
              value.NearFutureSegments.length > 0
                ? value.NearFutureSegments[0].StarttimeUTC
                : value.ClassDateTZ
            )) ||
            (value.Status !== "Attended" &&
              checkPastOrFutureDate(
                "isPast",
                value.NearFutureSegments.length > 0
                  ? value.NearFutureSegments[0].StarttimeUTC
                  : value.ClassDateTZ
            ))
        );
      }
    } else {
      const tempArr: any[] = [];
      if (type === "Diagnostics") {
        for (const className in dataArr) {
          if (dataArr.hasOwnProperty(className)) {
            const classArray = dataArr[className];
            classArray.forEach((element: any) => {
              if (selectedBtn[1] === true) {
                tempArr.push(element);
              } else if (selectedBtn[2] === true) {
                if (
                  element.Status !== "Complete" &&
                  element.Status !== "Completed" &&
                  checkPastOrFutureDate("isFuture", element.DueDate)
                ) {
                  tempArr.push(element);
                }
              } else if (selectedBtn[3] === true) {
                if (
                  element.Status === "Complete" ||
                  element.Status === "Completed"
                ) {
                  tempArr.push(element);
                }
              } else if (selectedBtn[4] === true) {
                if (
                  element.Status !== "Complete" &&
                  element.Status !== "Completed" &&
                  checkPastOrFutureDate("isPast", element.DueDate)
                ) {
                  tempArr.push(element);
                }
              }
            });
          }
        }
        return tempArr;
      } else if (type === "Attendance") {
        for (const className in dataArr) {
          if (dataArr.hasOwnProperty(className)) {
            const classArray = dataArr[className];
            classArray.forEach((element: any) => {
              if (selectedBtn[1] === true) {
                tempArr.push(element);
              } else if (selectedBtn[2] === true) {
                if (checkPastOrFutureDate("isFuture", element.ClassDateTZ)) {
                  tempArr.push(element);
                }
              } else if (selectedBtn[3] === true) {
                if (element.Status === "Attended") {
                  tempArr.push(element);
                }
              } else if (selectedBtn[4] === true) {
                if (
                  element.Status !== "Attended" &&
                  checkPastOrFutureDate("isPast", element.ClassDateTZ)
                ) {
                  tempArr.push(element);
                }
              }
            });
          }
        }
        return tempArr;
      } else if (type === "Homework") {
        for (const className in dataArr) {
          if (dataArr.hasOwnProperty(className)) {
            const classArray = dataArr[className];
            classArray.forEach((element: any) => {
              if (selectedBtn[1] === true) {
                tempArr.push(element);
              } else if (selectedBtn[2] === true) {
                if (
                  element.Status !== "Complete" &&
                  element.Status !== "Completed" &&
                  checkPastOrFutureDate("isFuture", element.DueDate)
                ) {
                  tempArr.push(element);
                }
              } else if (selectedBtn[3] === true) {
                if (
                  element.Status === "Complete" ||
                  element.Status === "Completed"
                ) {
                  tempArr.push(element);
                }
              } else if (selectedBtn[4] === true) {
                if (
                  element.Status !== "Complete" &&
                  element.Status !== "Completed" &&
                  checkPastOrFutureDate("isPast", element.DueDate)
                ) {
                  tempArr.push(element);
                }
              }
            });
          }
        }

        return tempArr;
      } else if (type === "TopicFocus") {
        for (const className in dataArr) {
          if (dataArr.hasOwnProperty(className)) {
            const classArray = dataArr[className];
            classArray.forEach((element: any) => {
              if (selectedBtn[1] === true) {
                tempArr.push(element);
              } else if (selectedBtn[2] === true) {
                if (
                  element.Status !== "Attended" &&
                  checkPastOrFutureDate(
                    "isFuture",
                    element.NearFutureSegments.length > 0
                      ? element.NearFutureSegments[0].StarttimeUTC
                      : element.ClassDateTZ
                  )
                ) {
                  tempArr.push(element);
                }
              } else if (selectedBtn[3] === true) {
                if (element.Status === "Attended") {
                  tempArr.push(element);
                }
              } else if (selectedBtn[4] === true) {
                if (
                  (element.Status === "Not Attended" && checkPastOrFutureDate(
                    "isPast",
                    element.NearFutureSegments.length > 0
                      ? element.NearFutureSegments[0].StarttimeUTC
                      : element.ClassDateTZ
                  )) ||
                  (element.Status !== "Attended" &&
                    checkPastOrFutureDate(
                      "isPast",
                      element.NearFutureSegments.length > 0
                        ? element.NearFutureSegments[0].StarttimeUTC
                        : element.ClassDateTZ
                    ))
                ) {
                  tempArr.push(element);
                }
              }
            });
          }
        }
        return tempArr;
      }

      return dataArr;
    }
  };

  const handleBack = () => {
    setIsShowMobileTestDetails && setIsShowMobileTestDetails((prev) => !prev);
  };

  return (
    <div className={classNames("progress-summary-mobile-wrapper")}>
      <div className={classNames("progress-summary-mobile-back-wrapper")}>
        <BackIcon
          color={theme === "light" ? "#233851" : "#329EE2"}
          onClickHandle={handleBack}
        />
        <Typography variant="h6Medium" label="Back" onClick={handleBack} />
      </div>
      <div className={classNames("progress-summary-mobile-title-wrapper")}>
        <Typography variant="h2Bold" label={getTitle(clickedGraphNameMobile)} />
      </div>
      {isLoading ? (
        <Spinner theme={theme} />
      ) : isError ? (
        <FetchError content="Oops! failed to load resources." />
      ) : (
        data && (
          <>
            {clickedGraphNameMobile === "Diagnostics" ? (
              <>
                <ProgressSummaryMobileFilters
                  selectedBtn={selectedBtn}
                  setSelectedBtn={setSelectedBtn}
                  setDropdownSelection={setFilterDropdown}
                  selectedOption={filterDropdown}
                  btnsLabelOrder={[
                    "View All",
                    "Upcoming",
                    "Complete",
                    "Past Due",
                  ]}
                  dropdownData={Object.keys(data.Diagnostics).sort((a, b) =>
                    a.localeCompare(b)
                  )}
                />
                <ProgressSummaryMobileTestDetails
                  type="Diagnostics"
                  data={getFilteterData(data.Diagnostics, "Diagnostics")}
                  theme={theme}
                />
              </>
            ) : null}
            {clickedGraphNameMobile === "Attendance" ? (
              <>
                <ProgressSummaryMobileFilters
                  selectedBtn={selectedBtn}
                  setSelectedBtn={setSelectedBtn}
                  setDropdownSelection={setFilterDropdown}
                  selectedOption={filterDropdown}
                  btnsLabelOrder={[
                    "View All",
                    "Upcoming",
                    "Attended",
                    "Not Attended",
                  ]}
                  dropdownData={Object.keys(data.Attendance).sort((a, b) =>
                    a.localeCompare(b)
                  )}
                />
                <ProgressSummaryMobileTestDetails
                  type="Attendance"
                  data={getFilteterData(data.Attendance, "Attendance")}
                  theme={theme}
                />
              </>
            ) : null}
            {clickedGraphNameMobile === "Homework" ? (
              <>
                <ProgressSummaryMobileFilters
                  selectedBtn={selectedBtn}
                  setSelectedBtn={setSelectedBtn}
                  setDropdownSelection={setFilterDropdown}
                  selectedOption={filterDropdown}
                  btnsLabelOrder={[
                    "View All",
                    "Upcoming",
                    "Complete",
                    "Past Due",
                  ]}
                  dropdownData={Object.keys(data.Homework).sort((a, b) =>
                    a.localeCompare(b)
                  )}
                />
                <ProgressSummaryMobileTestDetails
                  type="Homework"
                  data={getFilteterData(data.Homework, "Homework")}
                  theme={theme}
                />
              </>
            ) : null}
            {clickedGraphNameMobile === "Tests" ? (
              <>
                <ProgressSummaryMobileFilters
                  selectedBtn={selectedBtn}
                  setSelectedBtn={setSelectedBtn}
                  hideDropdown={true}
                  btnsLabelOrder={[
                    "View All",
                    "Upcoming",
                    "Complete",
                    "Past Due",
                  ]}
                />
                <ProgressSummaryMobileTestDetails
                  type="Tests"
                  data={getFilteterData(data.Tests, "Tests")}
                  theme={theme}
                />
              </>
            ) : null}
            {clickedGraphNameMobile === "TopicFocus" ? (
              <>
                <ProgressSummaryMobileFilters
                  selectedBtn={selectedBtn}
                  setSelectedBtn={setSelectedBtn}
                  setDropdownSelection={setFilterDropdown}
                  selectedOption={filterDropdown}
                  btnsLabelOrder={[
                    "View All",
                    "Upcoming",
                    "Attended",
                    "Not Attended",
                  ]}
                  dropdownData={Object.keys(data.TopicFocus).sort((a, b) =>
                    a.localeCompare(b)
                  )}
                />
                <ProgressSummaryMobileTestDetails
                  type="TopicFocus"
                  data={getFilteterData(data.TopicFocus, "TopicFocus")}
                  theme={theme}
                />
              </>
            ) : null}
          </>
        )
      )}
    </div>
  );
};
